module.exports = __webpack_public_path__ + "img/note.2002f8b1.svg";